var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoAttestation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 116,
    viewBox: "0 0 63 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tl6dq0s6he",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "egmz8ylbjc",
    width: "170%",
    height: "170%",
    x: "-35%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.388235294 0 0 0 0 0.549019608 0 0 0 0 0.796078431 0 0 0 0.45 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "5vx2jppqod",
    cx: 32,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "uqyspcgb6a",
    d: "M0 0L63 0 63 95 0 95z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-725 -207) translate(378 140) translate(0 5) translate(347 66) translate(0 17)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nul4htap8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uqyspcgb6a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C2D5ED",
    d: "M48.624 24.77H14.376c-.462 0-.838.378-.838.842 0 .465.376.842.838.842h34.248c.462 0 .838-.377.838-.842 0-.464-.376-.842-.838-.842zm0 8.467H14.376c-.462 0-.838.377-.838.842 0 .464.376.843.838.843h34.248c.462 0 .838-.379.838-.843 0-.465-.376-.842-.838-.842zm12.699 44.856h-11.39V72.02l.23-.15c3.28-2.15 5.239-5.772 5.239-9.688 0-6.375-5.162-11.561-11.507-11.561-6.346 0-11.508 5.186-11.508 11.56 0 3.917 1.959 7.538 5.24 9.688l.23.151v6.073H1.677V1.685h59.646v76.408zm-17.428-6.035c-5.42 0-9.831-4.43-9.831-9.876s4.41-9.877 9.83-9.877c5.421 0 9.83 4.431 9.83 9.877 0 5.445-4.409 9.876-9.83 9.876zm4.36 19.237l-.931-1.453-2.725-4.247c-.155-.242-.418-.386-.704-.386s-.55.144-.705.386l-2.725 4.247-.932 1.453V72.9l.67.229c1.193.407 2.435.614 3.692.614 1.256 0 2.499-.207 3.692-.614l.669-.229v18.395zM62.162 0H.84C.376 0 0 .378 0 .842v78.093c0 .465.376.843.839.843h37.018v14.38c0 .37.247.703.601.807.077.023.157.035.237.035.286 0 .55-.144.705-.386l4.069-6.345.426-.663.425.663 4.07 6.345c.155.242.418.386.704.386.08 0 .16-.012.237-.035.355-.104.602-.436.602-.807v-14.38H62.16c.463 0 .839-.378.839-.843V.842C63 .378 62.624 0 62.161 0zM7.473 72.752h17.841c.462 0 .838-.378.838-.842 0-.465-.376-.843-.838-.843H8.311V8.44H54.69v36.917c0 .465.376.843.838.843.462 0 .839-.378.839-.843V7.597c0-.464-.377-.842-.839-.842H7.473c-.462 0-.839.378-.839.843V71.91c0 .464.377.842.839.842zm41.15-30.508H14.377c-.462 0-.838.378-.838.842 0 .465.376.843.838.843h34.248c.462 0 .838-.378.838-.843 0-.464-.376-.842-.838-.842zM39.39 17.087c.462 0 .838-.378.838-.842 0-.465-.376-.843-.838-.843H23.61c-.462 0-.838.378-.838.843 0 .464.376.842.838.842h15.78zM14.376 61.339c-.462 0-.838.378-.838.843 0 .464.376.842.838.842h10.58c.462 0 .838-.378.838-.842 0-.465-.376-.843-.839-.843H14.376zm14.255-9.367H14.376c-.462 0-.838.378-.838.842 0 .465.376.843.838.843h14.255c.462 0 .838-.378.838-.843 0-.464-.376-.842-.838-.842z",
    mask: "url(#nul4htap8b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-725 -207) translate(378 140) translate(0 5) translate(347 66)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#egmz8ylbjc)",
    xlinkHref: "#5vx2jppqod"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#tl6dq0s6he)",
    xlinkHref: "#5vx2jppqod"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#EB2358",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L11.706 11.706",
    transform: "translate(-725 -207) translate(378 140) translate(0 5) translate(347 66) translate(26.794 14.605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L11.706 11.706",
    transform: "translate(-725 -207) translate(378 140) translate(0 5) translate(347 66) translate(26.794 14.605) matrix(-1 0 0 1 11.706 0)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAttestation);
export default __webpack_public_path__ + "static/media/icon-no-attestation.92cf683619820726c5707ec883a28b8c.svg";
export { ForwardRef as ReactComponent };